import { paintings } from './gallery_paintings'
import { illustration } from './gallery_illustration'
import { branding } from './gallery_design'
import { posters } from './gallery_posters'
import { collage } from './gallery_collage'
import { circular } from './gallery_circular'
import { comics } from './gallery_comics'
import { photos } from './gallery_photos'

export const images = {
  illustration: illustration,
  branding: branding,
  paintings: paintings,
  concert_posters: posters,
  // comics: comics,
  collage: collage,
  circular: circular,
  photos: photos
}


// WEBPACK FOOTER //
// ./src/store/constants/images.js